import {
	Avatar, getAvatarSource,
	AsyncComboboxAutocompleteOptionPrimitive,
	AutocompleteOption,
	forwardRefWithGenerics,
} from '@aleph/shared-components';
import { mapTypeNameToAvatarEntity } from 'wb-reddit/app/common/utils';
import { getUserInitials } from 'wb-reddit/app/routes/users/utils';

interface Option extends AsyncComboboxAutocompleteOptionPrimitive {
	userEmail?: string;
}

interface IProps<T extends Option> {
	option: T;
	onOptionClick?: (option: T) => void;
	onSelected?: () => void;
	searchQuery: string;
}

export const ComboboxAutocompleteOption = forwardRefWithGenerics(
	<T extends Option>(
		{ option, onOptionClick, onSelected }: IProps<T>,
		ref: React.ForwardedRef<HTMLDivElement>,
	) => (
		<AutocompleteOption
			ref={ref}
			image={
				<Avatar
					entityType={mapTypeNameToAvatarEntity(option)}
					src={getAvatarSource(option)}
					entityUserInitials={getUserInitials(option)}
				/>
			}
			label={option.label}
			instructions={option.userEmail?.split('@')[1]}
			onClick={() => {
				onOptionClick?.(option);
				onSelected?.();
			}}
		/>
	),
);
